import React from 'react'

import ChatStoreProvider from '@/components/chat/ChatStore/ChatStoreProvider'
import { ContainerComponent } from '@/components/commons/container/Container.component'
import { ConfirmationModalProvider } from '@/components/confirmationModal/ConfirmationModal'
import { ProductFruitsWrapper } from '@/components/productFruits'
import { MainLayoutV2 } from '@/layouts/MainLayoutV2'
import { profileContainer } from '@/styles/v2/pages/profile'
import clsx from 'clsx'
import { useUser } from 'containers/user/hooks/useUser'
import { ConnectionsModalProvider } from 'context/connectionsModal/ConnectionsModalProvider'
import { MenuProvider } from 'context/menu/MenuProvider'
import { ProfileProvider } from 'context/profilePage'
import { useRouter } from 'next/router'
import {
  appLayoutContentContainer,
  appLayoutContentContainerLoggedOut,
  appLayoutContentSection,
} from './AppLayout.css'
import { Footer } from './Footer/Footer'
import { Header } from './Header/Header'
import { NavigationTab, NavigationTabs } from './NavigationTabs/NavigationTabs'
import { Sidebar } from './Sidebar/Sidebar'

interface AppLayoutProps {
  children?: React.ReactNode
  title?: string
  className?: string
  image?: string
  description?: string
  canonicalPath?: string
}

export const AppLayout = ({
  children,
  title,
  className,
  image,
  description,
  canonicalPath,
}: AppLayoutProps) => {
  // https://github.com/vercel/next.js/discussions/11484
  const { isReady } = useRouter()
  const { isAuth } = useUser()

  const appLayoutContentContainerClass = isAuth
    ? appLayoutContentContainer
    : appLayoutContentContainerLoggedOut

  return (
    <MainLayoutV2
      title={title}
      image={image}
      description={description}
      canonicalPath={canonicalPath}
    >
      <MenuProvider>
        <ConfirmationModalProvider>
          <ChatStoreProvider>
            <ConnectionsModalProvider>
              <ProfileProvider>
                <ContainerComponent
                  variation="full"
                  className={[profileContainer]}
                >
                  <Header />

                  <div
                    className="flex flex-1 flex-row relative"
                    style={{ width: '100vw' }}
                  >
                    <Sidebar />
                    <div
                      className={clsx(
                        appLayoutContentContainerClass,
                        className
                      )}
                    >
                      {isReady ? children : null}
                    </div>
                    <ProductFruitsWrapper />
                  </div>
                  <Footer />
                </ContainerComponent>
              </ProfileProvider>
            </ConnectionsModalProvider>
          </ChatStoreProvider>
        </ConfirmationModalProvider>
      </MenuProvider>
    </MainLayoutV2>
  )
}

const AppBaseLayout = ({ children }) => {
  return <div className={appLayoutContentSection}>{children}</div>
}

AppLayout.BaseLayout = AppBaseLayout
AppLayout.NavigationTabs = NavigationTabs
AppLayout.NavigationTab = NavigationTab
